<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <h2 class="text-center mb-3">Avtale om oppgjør av sikkerhet</h2>
      </v-flex>
      <v-flex
        xs12
        class="text-xs-center mb-5"
        v-if="config.sendUnsignedButton && !reportSent"
      >
        <v-btn color="primary" v-on:click.stop="showSendUnsignedModal = true"
          >Send tilstandsrapport til deltakere</v-btn
        >
      </v-flex>
      <v-flex
        xs12
        class="text-xs-center mb-5"
        v-if="config.sendUnsignedButton && reportSent"
      >
        <h5 class="mt-3">Tilstandsrapport er nå sendt</h5>
      </v-flex>
      <v-flex xs12 sm6 class="pr-sm-3">
        <v-card class="mb-4 mt-4">
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-home</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title>Informasjon</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Adresse leiebolig"
                  v-model="address"
                  disabled
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Utleier" v-model="stepValues.landlord" />
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Leietaker" v-model="tenant" disabled />
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Forvalter" v-model="department" disabled />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 class="pl-sm-3">
        <v-card class="mb-4 mt-4">
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-bank</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title>Sikkerhet for leieforholdet</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <h5>Følgende sikkerhet er stilt for leieforholdet:</h5>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  :label="
                    'Depositumskonto ' +
                    protocol.version.protocol_definition.department.name
                  "
                  hint="Kontonummer for depositumskonto"
                  v-model="stepValues.bankAccountNr"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Leiegaranti Søderberg & Partners"
                  hint="Polisenr hos S&P"
                  v-model="stepValues.poliseNr"
                />
              </v-flex>
              <v-flex xs12>
                <h5 class="mt-3">
                  Leietaker gir med signatur av denne avtale sitt samtykke til
                  at {{ department }} melder avslutning av sikkerheten etter
                  endt leieforhold i {{ address }}.
                </h5>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card class="mb-4 mt-4">
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-cash-multiple</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title
              >Utestående husleie, gebyr og renter</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-if="stepValues.date != undefined"
                  type="text"
                  label="Leie til og med"
                  v-model="stepValues.date"
                  hint="Utleier og leietaker er enige om at leietaker skal betale husleie, gebyrer og renter frem til og med dato"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  type="number"
                  label="Husleie"
                  v-model="stepValues.rent"
                  suffix="NOK"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  type="number"
                  label="Gebyr"
                  v-model="stepValues.fee"
                  suffix="NOK"
                />
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  type="number"
                  label="Forsinkelsesrente"
                  v-model="stepValues.interest"
                  suffix="NOK"
                />
              </v-flex>
              <v-flex xs12 style="border-top: 1px solid #c9c9c9">
                <v-text-field
                  type="number"
                  label="Totalt"
                  v-model="sumTotal"
                  suffix="NOK"
                  disabled
                />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card class="mb-4 mt-4">
          <v-toolbar color="accent" :dark="protocol.dark">
            <v-toolbar-side-icon>
              <v-icon>mdi-alert-circle</v-icon>
            </v-toolbar-side-icon>
            <v-toolbar-title v-if="config.imburseHeadline != undefined">{{
              config.imburseHeadline
            }}</v-toolbar-title>
            <v-toolbar-title v-else
              >Erstatning for feil og mangler</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <h5>
                  Ved gjennomgang av boligen etter endt leieforhold ble det
                  avdekket følgende avvik som utleier mener utgjør feil og
                  mangler ut over den normale slitasje og elde som må påregnes
                  ved utleie av bolig. Dersom beløp ikke framkommer nedenfor
                  kreves leietakers seperate samtykke for avslutning. Det samme
                  gjelder dersom leietaker ikke er enig i den oppførte mangel.
                </h5>
              </v-flex>
              <v-flex xs12 class="mt-3">
                <BooleanInputTableWithSum
                  objectTitle="Registrerte mangler"
                  boolTitle="Leietaker aksepterer?"
                  commentTitle="Kommentar"
                  v-model="stepValues.questions"
                  @update-fields="updateFields"
                />
              </v-flex>
              <v-flex xs12 class="mt-2">
                Utleier kan melde øvrige krav som måtte dukke opp «innen rimelig
                tid» jf. husleieloven § 10-3.
              </v-flex>
              <v-flex xs12 class="mt-4">
                Sikkerheten skal avsluttes med fratrekk for utestående husleie,
                gebyr og renter, samt fratrekk for eventuelle aksepterte mangler
                i denne avtale. De krav som er akseptert av denne avtale skal
                utbetales {{ department }} på konto på vegne av utleier.
              </v-flex>
              <template v-if="showTenantAccount">
                <v-flex xs12 >
                  <v-text-field
                    label="Leietakers kontonummer for utbetaling av depositum:"
                    v-model="stepValues.tenantAccountNr"
                  />
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs12 v-if="config.tenantAccountMessage" >
                  {{config.tenantAccountMessage}}
                </v-flex>
              </template>
              <v-flex xs12 mt-2>
                <v-text-field
                  :label="'Kontonummer ' + department"
                  v-model="stepValues.accountNr"
                />
              </v-flex>
              <v-flex xs12 v-if="stepValues.kidNr != undefined">
                <v-text-field label="KID-nummer" v-model="stepValues.kidNr" />
              </v-flex>
              <v-flex xs12 class="mb-3">
                <v-textarea box label="Kommentarer/Diverse" v-model="stepValues.comment" @input="updateFields"></v-textarea>
              </v-flex>
              <div v-html="config.info" v-if="config.info" class="mb-3"></div>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12 class="mb-3">
        <StepButtons @next-page="next" @previous-page="previous" :step="this" />
      </v-flex>
      <v-dialog v-model="showSendUnsignedModal" width="400" color="primary">
        <v-card>
          <v-card-title class="headline success" primary-title
            >Send tilstandsrapport til deltakere</v-card-title
          >

          <v-card-text>
            <h4>
              Her kan man sende en tilstansrapport til alle deltakere av
              protokollen
            </h4>
            <h5 class="mt-4 mb-3">
              Denne vil ikke være signert, men vise alle steg i protokollen frem
              til dette punkt
            </h5>
            <v-btn
              color="primary btn-block"
              v-on:click.stop="sendReport()"
              :loading="reportLoader"
              >Send rapport nå</v-btn
            >
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              v-on:click.stop="showSendUnsignedModal = false"
              >Lukk</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import BooleanInputTableWithSum from "../form/BooleanInputTableWithSum.vue";
import step from "../../mixins/step";
export default {
  mixins: [step],
  components: {
    BooleanInputTableWithSum,
  },
  data() {
    return {
      showSendUnsignedModal: false,
      reportLoader: false,
      reportSent: false,
    };
  },
  computed: {
    address: function () {
      return (
        this.protocol.saved_values.address.street +
        " " +
        this.protocol.saved_values.address.zip +
        " " +
        this.protocol.saved_values.address.city
      );
    },
    tenant: function () {
      if (this.protocol.saved_values.participants.tenants.length > 0) {
        return (
          this.protocol.saved_values.participants.tenants[0].firstname +
          " " +
          this.protocol.saved_values.participants.tenants[0].lastname
        );
      }
      return null;
    },
    showTenantAccount: function () {
      if(this.config.hideTenantAccountNr != undefined && this.config.hideTenantAccountNr != null) {
        if(this.config.hideTenantAccountNr) {
          return false
        }
      }
      return true
    },
    department: function () {
      return this.protocol.version.protocol_definition.department.name;
    },
    sumTotal: function () {
      let rent = isNaN(parseInt(this.stepValues.rent))
        ? 0
        : parseInt(this.stepValues.rent);
      let fee = isNaN(parseInt(this.stepValues.fee))
        ? 0
        : parseInt(this.stepValues.fee);
      let interest = isNaN(parseInt(this.stepValues.interest))
        ? 0
        : parseInt(this.stepValues.interest);
      return rent + fee + interest;
    },
  },
  activated: function () {
    if (this.protocol.saved_values.participants.tenants.length == 0) {
      this.$emit("error", "Vennligst velg deltakere tilstede");
      this.$router.push("tilstede");
    }
    if (!this.stepValues.landlord) {
      if (this.protocol.saved_values.participants.landlords.length > 0) {
        this.stepValues.landlord =
          this.protocol.saved_values.participants.landlords[0].firstname +
          " " +
          this.protocol.saved_values.participants.landlords[0].lastname;
      }
    }
  },
  methods: {
    sendReport() {
      this.reportLoader = true;
      this.axios
        .post(
          process.env.VUE_APP_PROTOCOL_API +
            "protocols/" +
            this.$store.state.protocolHash +
            "/sendUnsignedReport",
          this.$store.state.protocol.saved_values
        )
        .then(() => {
          this.reportSent = true;
          this.showSendUnsignedModal = false;
        })
        .catch((reportLoader) => {
          this.loader = false;
          this.$emit(
            "error",
            "Det skjedde en feil ved signering av protokoll. Sørg for at du er koblet til internett og forsøk på nytt"
          );
        })
        .finally(() => {
          this.reportLoader = false;
        });
    },
  },
};
</script>
